import { attr, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { currencyFormatter } from '../utils/functions';

const Extra = ApplicationRecord.extend({
  static: {
    jsonapiType: 'extras',
  },
  attrs: {
    abbreviation: attr(),
    name: attr(),
    quantity: attr(),
    extra_type_id: attr(),
    image: attr({ persist: false }),
    orderPackages: hasMany(),
    prices: hasMany(),
  },
  methods: {
    /* options: { format: 'currency' | undefined } */
    price: function(options = {}) {
      const num = options.usePriceWithout && this.prices[0].priceWithout ? this.prices[0].priceWithout : this.prices[0].price

      if (options.format === 'currency') return currencyFormatter(num);

      return num;
    },
  }
});

export default Extra;
